import CallOutcomeModal from './CallOutcomeModal';

export default CallOutcomeModal;
